import { supabase } from './supabase';

export async function addPlatformTeamSeat(
  businessId: string,
): Promise<{ success: true; quantity: number } | { success: false; error: string }> {
  if (!supabase) {
    return { success: false, error: 'App not initialized' };
  }
  const { data, error } = await supabase.functions.invoke('stripe-subscription', {
    body: { action: 'add-platform-team-seat', businessId },
  });
  if (error) {
    return { success: false, error: error.message || 'Request failed' };
  }
  if (data && typeof data.error === 'string') {
    return { success: false, error: data.error };
  }
  if (!data?.success) {
    return { success: false, error: 'Unexpected response from server' };
  }
  return { success: true, quantity: Number(data.quantity) || 0 };
}

export async function removePlatformTeamSeat(
  businessId: string,
): Promise<{ success: true; quantity: number } | { success: false; error: string }> {
  if (!supabase) {
    return { success: false, error: 'App not initialized' };
  }
  const { data, error } = await supabase.functions.invoke('stripe-subscription', {
    body: { action: 'remove-platform-team-seat', businessId },
  });
  if (error) {
    return { success: false, error: error.message || 'Request failed' };
  }
  if (data && typeof data.error === 'string') {
    return { success: false, error: data.error };
  }
  if (!data?.success) {
    return { success: false, error: 'Unexpected response from server' };
  }
  return { success: true, quantity: Number(data.quantity) || 0 };
}
